import { useState, useEffect } from 'react'
import { detectUserTaxSystem } from '../utils/tax/detection'
import type { TaxSystem } from '../types/tax'

export const useTaxSystem = () => {
  const [taxSystem, setTaxSystem] = useState<TaxSystem>(() =>
    detectUserTaxSystem()
  )

  useEffect(() => {
    setTaxSystem(detectUserTaxSystem())
  }, [])

  return taxSystem
}
